<template>
  <div class="statistics">
    <div class="top">
      <div class="card">
        <div class="list" v-if="teamList.home.playerList && teamList.home.playerList.length > 0">
          <div class="item" :class="player && player.id === item.id ? 'active':''" v-for="(item,i) in teamList.home.playerList" :key="i" @click="selectPlayer(item)">
            <div>{{ item.number }}</div>
            <div>{{ item.trueName }}</div>
          </div>
        </div>
        <div class="list" v-else>无球员</div>
        <div class="info" v-if="player">
          <p>{{ player.team.name }}</p>
          <img :src="imageView(player.avatar)" />
          <div>({{ player.number }}) {{ player.trueName }}</div>
        </div>
        <div class="info" v-else>未选择球员</div>
        <div class="list" v-if="teamList.away.playerList && teamList.away.playerList.length > 0">
          <div class="item" :class="player && player.id === item.id ? 'active' : ''" v-for="(item, i) in teamList.away.playerList" :key="i" @click="selectPlayer(item)">
            <div>{{ item.number }}</div>
            <div>{{ item.trueName }}</div>
          </div>
        </div>
        <div class="list" v-else>无球员</div>
      </div>
    </div>
    <div class="minute" v-if="player">
      <MyField label="得分">
        <Stepper2 v-model="player.goalEventCount"  @input="player.score = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="助攻">
        <Stepper2 v-model="player.assistEventCount"  @input="player.assist = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="红牌">
        <Stepper2 v-model="player.redCardEventCount"  @input="player.rebound = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="黄牌">
        <Stepper2 v-model="player.yellowCardEventCount"  @input="player.steal = $event" background="#F9FAFC" />
      </MyField>
      <div class="but" @click="goPages">
        查看完整统计
      </div>
    </div>
  </div>
</template>

<script>
import MyField from '../../components/Field.vue'
import Stepper2 from '@/components/Stepper2.vue'
import { QNImageUtil } from '@/utils'
import {
  adminGetBMBktGameData,
  adminGetBMBktGameEventPlayerList,
  bMMatchOrganizationUpdateBMGameEvents
} from "@/api/match";
export default {
  props: {
    isMe: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MyField,
    Stepper2
  },
  data() {
    return {
      id: '',
      matchId:'',
      game: {},
      teamList: {
        home: {},
        away: {}
      },
      player:false
    };
  },
  mounted() {
    this.id = this.$route.query.id
    this.matchId = this.$route.query.matchId
    this.adminGetBMBktGameData()
  },
  watch: {
    isMe() {
      if (this.isMe) {
        this.adminGetBMBktGameData()
      }
    }
  },
  methods: {
    goPages() {
      this.$router.push({ path: '/match-manage/football-collect', query: { gameId : this.id}})
    },
    adminGetBMBktGameData() {
      adminGetBMBktGameData({ gameId: this.id }).then(res => {
        this.game = res.data.game
        // adminGetBMBktGameEventPlayerList
        const home = new Promise((resolve, reject) => {
          adminGetBMBktGameEventPlayerList({ matchId :this.matchId ,teamId: this.game.homeTeam.id, gameId: this.id }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        const away = new Promise((resolve, reject) => {
          adminGetBMBktGameEventPlayerList({ matchId: this.matchId, teamId: this.game.awayTeam.id, gameId: this.id }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        this.getTeamList(home, away)
      })
    },
    getTeamList(home, away) {
      Promise.all([home, away]).then(results => {
        console.log('success:', results)
        const home = results[0]
        const away = results[1]
        this.teamList.home = home.data
        this.teamList.away = away.data
        if (home.data.playerList.length > 0) {
          this.player = home.data.playerList[0]
        } else if (away.data.playerList.length > 0) {
          this.player = away.data.playerList[0]
        } else {
          this.player = false
        }
      })
    },
    selectPlayer(obj) {
      this.update().then(() => {
        this.player = obj
      })
    },
    update() {
      return new Promise((resolve) => {
        const params = {
          playerId: this.player.id,
          teamId: this.player.team.id,
          gameId: this.id,
          goal: this.player.goalEventCount,
          assist: this.player.assistEventCount,
          red: this.player.redCardEventCount,
          yellow: this.player.yellowCardEventCount
        }
        if(!params.playerId) return
        bMMatchOrganizationUpdateBMGameEvents(params).then((res) => {
          resolve(res)
        })
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
  },
  beforeDestroy() {
    if (this.isMe) {
      this.update()
    }
  }
};
</script>

<style scoped lang="scss">
.statistics{
  .top{
    padding: 16px;
    background-color: #fff;
    .card{
      border-radius: 4px;
      background: #F3F5FA;
      padding: 12px;
      height: 219px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }
    .list{
      min-width: 72px;
      overflow: scroll;
      &::-webkit-scrollbar {
        /*隐藏滚轮*/
        display: none;
      }
      .item{
        width: 60px;
        height: 60px;
        background: #FFFFFF;
        border-radius: 2px;
        text-align: center;
        color: rgba(25,25,25,0.7);
        font-size: 14px;
        margin-bottom: 4px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 0 6px;
      }
      .active{
        width: 58px;
        height: 58px;
        border: 1px solid #1565FC;
        color: #1565FC;
      }
    }
    .info{
      align-self: center;
      text-align: center;
      p{
        font-size: 14px;
        color: rgba(25,25,25,0.7);
        margin-bottom: 13px;
      }
      img{
        width: 90px;
        height: 120px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
      }
      div{
        font-size: 14px;
        font-weight: 500;
        color: #191919;
        margin-top: 12px;
      }
    }
  }
  .minute{
    margin-top: 12px;
    background-color: #fff;
    padding-left: 22px;
    padding-right: 16px;
    .but{
      color: #1565FC;
      font-size: 14px;
      padding: 17px 0;
      background-color: #fff;
      text-align: center;
    }
  }
}
</style>
